import 'dotenv/config';

const config = {
  URL_BASE: process.env.REACT_APP_URL_BASE,
  NETLIFY_BASE: process.env.REACT_APP_NETLIFY_BASE,
};
export default config;
